import { render } from "./create.vue?vue&type=template&id=5c1042c6"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/components/pages/passwordResets/create.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c1042c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c1042c6', __exports__)) {
    api.reload('5c1042c6', __exports__)
  }
  
  module.hot.accept("./create.vue?vue&type=template&id=5c1042c6", () => {
    api.rerender('5c1042c6', render)
  })

}


export default __exports__